export const DEFAULT_PORT = 1255
export const FIRST_LEVEL_HEOS_RESPONSE_MESSAGE_SPLITTER = '&'
export const SECOND_LEVEL_HEOS_RESPONSE_MESSAGE_SPLITTER = '='
